import { useParams } from 'react-router-dom';
import { REDIRECT_ORG_PREFIX } from 'constants/routes.js';
import useRedirect from 'hooks/useRedirect.js';

const OrgRedirect = () => {
  const { orgId } = useParams();
  useRedirect(`${REDIRECT_ORG_PREFIX}/${orgId}`, `${orgId}`);

  return null;
};

export default OrgRedirect;
